import comp from "./AssignmentEvaluationAICallout";
export default comp;
